import { useState, type FormEvent } from "react";
import { auth } from "../lib/auth";
import { navigate } from "../lib/router";

/** Куда вернуться после входа: ?next=/ru/Si (только внутренние пути). */
function nextPath() {
  const n = new URLSearchParams(window.location.search).get("next");
  return n && n.startsWith("/") && !n.startsWith("//") ? n : "/ru";
}

export function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await auth.login(username, password);
      navigate(nextPath());
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
      setPassword("");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="page auth-page">
      <form className="auth-card" onSubmit={submit}>
        <h1>Вход</h1>
        <p className="muted">Все инструменты, графики и сигналы открываются после входа.</p>
        <label className="field">
          <span>Логин</span>
          <input
            autoFocus
            autoComplete="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </label>
        <label className="field">
          <span>Пароль</span>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        {error && (
          <p className="form-error" role="alert">
            {error}
          </p>
        )}
        <button type="submit" className="btn btn-primary" disabled={busy}>
          {busy ? "Входим…" : "Войти"}
        </button>
        <p className="muted small">Нет доступа? Логин выдаёт администратор сайта.</p>
      </form>
    </main>
  );
}
